import styled from 'styled-components';
import { ArrowUpward, ArrowDownward } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';

const StyledArrowUpwardIcon = withStyles({
  root: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#69b34c',
  },
})(ArrowUpward);

const StyledArrowUpwardIconSmall = withStyles({
  root: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#69b34c',
  },
})(ArrowUpward);

export const ArrowUpIcon = styled(StyledArrowUpwardIcon)``;

export const ArrowUpIconSmall = styled(StyledArrowUpwardIconSmall)``;

const StyledArrowDownIcon = withStyles({
  root: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#ff6161',
  },
})(ArrowDownward);

const StyledArrowDownIconSmall = withStyles({
  root: {
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#ff6161',
  },
})(ArrowDownward);

export const ArrowDownIcon = styled(StyledArrowDownIcon)``;

export const ArrowDownIconSmall = styled(StyledArrowDownIconSmall)``;

export const Container = styled.div`
  transition: all 0.3s ease-in;
  border-radius: 7px;
  background-color: white;
  display: flex;
  flex-direction: column;
  width: 279px;
  gap: 15px;
  padding: 20px;
  &:hover {
    cursor: ${props => (props.onClick ? 'pointer' : 'auto')};
    box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
  }
`;

export const Title = styled.div`
  font-family: Poppins;
  font-weight: 500;
  font-style: Medium;
  font-size: 12px;
  text-transform: uppercase;
  color: black;
`;

export const Row = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  position: relative;
  overflow: hidden;
  width: 100%;
`;

export const Column = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Statistics = styled.span`
  font-family: Poppins;
  font-weight: 600;
  font-style: SemiBold;
  font-size: ${props => props.fontSize || '34px'};
  color: #007ade;
`;

export const ABwrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  line-height: 16px;
  color: #555555;
  padding: 4px 0;
`;

export const Line = styled.div`
  position: relative;
  padding: 0 0 5px;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 279px;
    height: 0.5px;
    background-color: #e4e4e4;
  }
`;

export const Divider = styled.div`
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: -30px;
    min-height: 70px;
    border: 0.5px solid #e4e4e4;
  }
`;

export const EmptySpace = styled.span`
  height: 20px;
`;

export const ABstatistics = styled.span`
  flex: 1;
  font-family: Poppins;
  font-weight: 600;
  font-style: SemiBold;
  font-size: 11px;
  color: #000000;
`;

export const ResendStats = styled.span`
  color: #595659;
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  padding: 3px 3px 0;
  font-family: Poppins;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
`;

export const Resend = styled.span`
  font-size: 11px;
  gap: 5px;
  display: flex;
  font-family: Poppins;
  font-weight: 400;
  color: #595659;
`;

export const AverageStats = styled.span`
  font-family: Poppins;
  font-weight: 500;
  font-size: 12px;
  color: #007ade;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
`;
